import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_AppHomeTop = _resolveComponent("AppHomeTop")!
  const _component_app_main_footer = _resolveComponent("app-main-footer")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!

  return (_openBlock(), _createBlock(_component_app_main_layout, null, {
    "top-nav": _withCtx(() => [
      _createVNode(_component_app_top_nav)
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_AppHomeTop),
        _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_app_main_footer)
    ]),
    _: 1
  }))
}